import { useDataValue, useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let professional = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'search',
    viewPath: props.viewPath,
    path: 'view_details',
  })
  return function onClick() {
    change(professional)
  }
}
